import { createApiRequestType, strictObjectAccess } from '@ackee/redux-utils';

import { EntityKey } from 'constants/index';

const apiRequestType = createApiRequestType({ modulePrefix: EntityKey.FLOOR_ACTIVITY });

export const fetchFloorActivityTypes = strictObjectAccess({
    ...apiRequestType({ typePrefix: 'FETCH_FLOOR_ACTIVITY_' }),
});
